<img
  [ngStyle]="style"
  [src]="getSantizeUrl()"
  [ngClass]="{
    'md:w-full md:h-auto object-contain ': style?.fullWidth
  }"
/>
